import { Filter, FilterSelect } from "@/components/filters";
import dynamic from "next/dynamic";

const Map = dynamic(
  () => import("@/components/sections/landing-page/gis/map"),
  {
    ssr: false,
  }
);

const MapSection = () => {
  return (
    <div className="container mx-auto py-14 flex flex-col gap-5">
      <div className="flex flex-col gap-2 ">
        <div className="text-2xl md:text-3xl font-semibold">
          Peta Sebaran Poktan
        </div>
        <div className="text-[#5A5A5A] text-sm md:text-base">
          Lihat sebaran kelompok tani (Poktan) aktif di wilayah Kabupaten
          Penukal Abab Lematang Ilir. Pantau perkembangan, lokasi, dan aktivitas
          masing-masing Poktan secara interaktif.
        </div>
      </div>
      {/*  */}
      <Filter initialValues={{ type: "" }}>
        <div className="flex justify-end gap-2 items-center">
          <div className="w-full md:max-w-sm">
            <FilterSelect
              name="type"
              options={[
                { label: "Semua", value: "" },
                { label: "Poktan", value: "poktan" },
                { label: "Instansi", value: "instansi" },
              ]}
              label="Pihak"
              orientation="vertical"
            />
          </div>
        </div>
      </Filter>
      {/* map */}
      <div className="">
        <Map />
      </div>
    </div>
  );
};

export default MapSection;
